import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function SIFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-q4jlieve6" fill="#fff">
            <rect width="32" height="24" fillRule="evenodd" rx="2" />
          </mask>
          <mask id="mantine-jlnvlepnz" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-q6g2p5sed" />
          </mask>
          <path id="mantine-q6g2p5sed" d="M0 0h32v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-q4jlieve6)">
          <use fill="#2e42a5" xlinkHref="#mantine-q6g2p5sed" />
          <path fill="#f7fcff" d="M0 0h32v8H0z" mask="url(#mantine-jlnvlepnz)" />
          <path fill="#c51918" d="M0 16h32v8H0z" mask="url(#mantine-jlnvlepnz)" />
          <g mask="url(#mantine-jlnvlepnz)">
            <path
              fill="#2e42a5"
              d="M13.74 5.036c-1.403-.662-2.977-.994-4.722-.994-1.746 0-3.32.332-4.723.994.156 2.663.358 4.7.605 6.111.158.904.917 2.222 1.605 2.845.523.474 1.36.992 2.513 1.554.5-.345 1.435-.5 2.63-1.554.798-.702 1.295-1.65 1.493-2.845z"
            />
            <path
              fill="#c51918"
              fillRule="nonzero"
              d="M13.462 4.906l.876.437-.601 6.023c-.211 1.275-.738 2.28-1.582 3.023a6.845 6.845 0 01-1.382.955c-.27.141-1.4.723-1.391.719-.113.054-.2.102-.269.15l-.11.075-.117-.057c-1.171-.57-2.263-1.338-2.806-1.83-.741-.673-1.522-2.048-1.689-3-.249-1.423-.472-3.384-.63-6.058l.788-.412c.156 2.654.344 4.768.588 6.166.145.827.865 2.095 1.523 2.692.485.44 1.268.928 2.344 1.46a3.03 3.03 0 01.216-.114c.003-.002.735-.327.989-.46a6.4 6.4 0 001.288-.889c.748-.66 1.216-1.548 1.405-2.677z"
            />
            <path
              fill="#fff"
              d="M10.15 13.002a.455.455 0 01.268.063c.263.144.566.234.842.247l-.044.056-.15.177c-.504.565-1.199.982-2.085 1.25a5.948 5.948 0 01-2.079-1.37c.24.005.414-.058.526-.2.066-.086.266-.17.496-.205.107-.017.21-.02.287-.012.034.003.061.01.078.016.194.292.69.446 1.157.25l-.057.012a6.57 6.57 0 00.472-.197.938.938 0 01.29-.087zm.246-.706a.627.627 0 01.328.067c.324.154.7.245 1.03.245a9.557 9.557 0 01-.216.328c-.252.067-.653-.01-.976-.186a.752.752 0 00-.437-.1c-.116.01-.23.045-.382.11-.03.014-.314.144-.412.185l.058-.012c-.397.153-.744.04-.843-.123-.177-.292-1.103-.15-1.364.185-.07.09-.283.106-.635.017a4.178 4.178 0 01-.242-.338c.462.088.774.046.946-.147.08-.09.318-.176.589-.213.126-.017.247-.02.34-.012.042.004.077.01.1.019.008.002.007.002-.003-.013l.002.004.057.067c.219.227.663.347 1.107.234l.134-.042-.051.01a3.49 3.49 0 00.15-.051l.166-.062.21-.082c.148-.056.25-.083.344-.09zM8.98 8.444l1.159 1.653.698-.757 1.755 1.684c-.207.449-.413.853-.618 1.212-.302.058-.756-.022-1.122-.196a.924.924 0 00-.48-.096c-.128.01-.254.043-.426.108-.034.013-.36.144-.472.185l.05-.01c-.455.157-.873.039-.991-.132-.193-.277-1.224-.139-1.513.186-.107.12-.462.12-1.045-.048l.085.025a7.646 7.646 0 01-.519-1.234L7.266 9.34l.744.757z"
            />
            <path
              fill="#feca00"
              d="M7.147 5.886h-.703l.545-.51-.545-.54h.703l.297-.525.298.524h.702l-.518.508.46.543h-.644l-.298.553zm3.313 0h-.703l.546-.51-.546-.54h.704l.296-.525.299.524h.701l-.518.508.46.543h-.643l-.299.553zM8.6 7.567h-.703l.545-.51-.545-.54H8.6l.297-.524.298.524h.702l-.518.507.46.543h-.644l-.298.553z"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
}
